<template>
  <div class="container-fluid">
    <section class="row">
      <div>
        <div class="mt-3 text-center">
          <img src="../../assets/join_car.png" class="w-50"/>
        </div>
        <h5 class="text-center fs-title fw-bold mb-3">완료되었습니다.</h5>
        <p class="text-center fs-5 fw-bold">
          최대한 빠른 시일 내로<br/>
          담당 직원이 연락드리겠습니다.
        </p>
        <p class="text-center fs-5 fw-bold">
          감사합니다.
        </p>
      </div>
    </section>
    <footer class="footer d-flex flex-column mt-3 d-flex gap-1">
      <button class="btn btn-primary col-12 rounded-pill" @click="moveAfter">확인</button>
    </footer>
  </div>
</template>

<script>
/**
 * 간편회원가입 - 가입 완료페이지
 */
export default {
  name: "MemberFinalFin",
  data(){
    return {}
  },
  methods:{
    moveAfter(){

      let isMancharo = this.$store.getters.getJoinUrl;

      let url = "https://www.2424-2424.com";
      if(isMancharo === 'mancharo') {
        url = "https://mancharo.com/";
      }

      window.location.href = url;
    },
  },
}
</script>

<style scoped>

</style>